<script>
import VAutocomplete from 'vuetify/es5/components/VAutocomplete/VAutocomplete'
import { wrapperMixin } from './TextField'

export default {
    name: 'Autocomplete',
    extends: VAutocomplete,
    mixins: [wrapperMixin]
}
</script>
